import {
  Action, Module, Mutation, VuexModule,
} from 'vuex-module-decorators';

import {
  API_HUB_URL,
  BASE_URL,
  FECTH_AGENT,
  GAME_REPORT, GAME_REPORT_NIGHTLY,
  GAME_REPORT_REDIS,
  GENERATE_EXCEL_INVOICE,
  GENERATE_PDF_INVOICE,
  INVOICE_REPORT,
  M_POST,
  PROVIDER_REPORT,
  PROVIDER_TYPE_REPORT,
  TRANSACTION_REPORT,
  WINLOSE_DOWNLOAD_REPORT_CSV,
  WINLOSE_LOG_ELASTIC,
  WINLOSE_LOG_ELASTIC_MECHANIC,
  WINLOSE_RANGE_DATE_REPORT_LOGS,
  WINLOSE_RANGE_DATE_REPORT_LOGS_MECHANIC,
  WINLOSE_REPORT,
  WINLOSE_REPORT_LOGS,
  WINLOSE_REPORT_MECHANIC,
  WINLOSE_REPORT_NEW, WINLOSE_REPORT_NIGHTLY,
  WINLOSE_ROUND_AMBSUPERGAME,
  FETCH_ROUND_ID,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'report', namespaced: true })
export default class Report extends VuexModule {
  dataWinLose: any = {};

  dataWinLoseLog: any = {};

  dataNewWinLoseLog: any = {};

  dataGame: any = [];

  dataInvoice: any = {};

  dataFile: any = {};

  dataCSV: Blob | null = null;

  @Mutation
  mutateWinLose(dataWinLose: any) {
    this.dataWinLose = dataWinLose;
  }

  @Action({ commit: 'mutateWinLose' })
  FetchWinLose(criteria: object) {
    return Vue.axios({
      url: BASE_URL + WINLOSE_REPORT,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          const dataWinLose = data.data;
          return {
            ...dataWinLose,
          };
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Mutation
  mutateWinLoseLog(dataWinLoseLog: any) {
    this.dataWinLoseLog = dataWinLoseLog.dataWinLoseLog;
  }

  @Mutation
  mutateNewWinLose(dataWinLose: any) {
    this.dataNewWinLoseLog = dataWinLose;
  }

  @Action({ commit: 'mutateWinLose' })
  FetchNewWinLose(criteria: object) {
    return Vue.axios({
      url: BASE_URL + WINLOSE_REPORT_NEW,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action({ commit: 'mutateWinLose' })
  FetchNewWinLoseNightly(criteria: object) {
    return Vue.axios({
      url: BASE_URL + WINLOSE_REPORT_NIGHTLY,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action({ commit: 'mutateNewWinLose' })
  FetchWinLoseRangeLog(criteria: object) {
    return Vue.axios({
      url: BASE_URL + WINLOSE_RANGE_DATE_REPORT_LOGS,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          const dataWinLoseRangeLog = data.data;
          return {
            ...dataWinLoseRangeLog,
          };
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action({ commit: 'mutateNewWinLose' })
  FetchRoundId(criteria: object) {
    return Vue.axios({
      url: BASE_URL + FETCH_ROUND_ID,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          const dataWinLoseRangeLog = data.data;
          return {
            ...dataWinLoseRangeLog,
          };
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action({ commit: 'mutateNewWinLose' })
  FetchWinloseLogElastic(criteria: object) {
    return Vue.axios({
      url: BASE_URL + WINLOSE_LOG_ELASTIC,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          const dataLogElastic = data.data;
          return {
            ...dataLogElastic,
          };
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  // WIN_LOSE_MECHANIC

  @Action({ commit: 'mutateWinLose' })
  FetchNewWinLoseMechanic(criteria: object) {
    return Vue.axios({
      url: BASE_URL + WINLOSE_REPORT_MECHANIC,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action({ commit: 'mutateWinLoseLog' })
  FetchWinLoseLogMechanic(criteria: object) {
    return Vue.axios({
      url: BASE_URL + WINLOSE_REPORT_LOGS,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          const dataWinLoseLog = data.data.reportLog;
          dataWinLoseLog.sort((a, b) => b.timestamp.localeCompare(a.timestamp));
          return {
            dataWinLoseLog,
            breadcrumb: data.data.breadcrumb,
            paginationDetail: data.data.paginationDetail,
            footerSummaryLog: data.data.footerSummaryLog,
            totaldata: data.data.reportCount,
          };
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action({ commit: 'mutateNewWinLose' })
  FetchWinLoseRangeLogMechanic(criteria: object) {
    return Vue.axios({
      url: BASE_URL + WINLOSE_RANGE_DATE_REPORT_LOGS_MECHANIC,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          const dataWinLoseRangeLog = data.data;
          return {
            ...dataWinLoseRangeLog,
          };
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action({ commit: 'mutateNewWinLose' })
  FetchWinloseLogElasticMechanic(criteria: object) {
    return Vue.axios({
      url: BASE_URL + WINLOSE_LOG_ELASTIC_MECHANIC,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          const dataLogElastic = data.data;
          return {
            ...dataLogElastic,
          };
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  FetchResultAmbSuperGame(params) {
    return Vue.axios({
      url: API_HUB_URL + WINLOSE_ROUND_AMBSUPERGAME,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const {
          code,
          message,
        } = data.status;
        if (code === 0) {
          return data;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Mutation
  mutateGameReport(dataGame: any) {
    this.dataGame = dataGame;
  }

  @Action({ commit: 'mutateGameReport' })
  FetchGameReport(criteria: object) {
    return Vue.axios({
      url: BASE_URL + GAME_REPORT,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action({ commit: 'mutateGameReport' })
  FetchGameReportNightly(criteria: object) {
    return Vue.axios({
      url: BASE_URL + GAME_REPORT_NIGHTLY,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action({ commit: 'mutateGameReport' })
  FetchGameReportWithRedis(criteria: object) {
    return Vue.axios({
      url: BASE_URL + GAME_REPORT_REDIS,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  FetchProviderReport(criteria: object) {
    return Vue.axios({
      url: BASE_URL + PROVIDER_REPORT,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  FetchProviderReportByType(criteria: object) {
    return Vue.axios({
      url: BASE_URL + PROVIDER_TYPE_REPORT,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Mutation
  mutateInvoice(data: any) {
    this.dataInvoice = data;
  }

  @Action({ commit: 'mutateInvoice' })
  FetchInvoice(criteria: object) {
    return Vue.axios({
      url: BASE_URL + INVOICE_REPORT,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          const dataInvoice = data.data;
          return {
            ...dataInvoice,
          };
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Mutation
  mutateFileExcel(data: any) {
    this.dataFile = data;
  }

  @Action({ commit: 'mutateFileExcel' })
  generateFileExcel(dataInvoice: object) {
    return Vue.axios({
      url: BASE_URL + GENERATE_EXCEL_INVOICE,
      responseType: 'blob',
      data: dataInvoice,
      method: M_POST,
    })
      .then(({ data }) => {
        const dataFile = data;
        return {
          dataFile,
        };
      })
      .catch((err) => err);
  }

  @Mutation
  mutateFilePdf(data: any) {
    this.dataFile = data;
  }

  @Action({ commit: 'mutateFilePdf' })
  generateFilePdf(dataInvoice: object) {
    return Vue.axios({
      url: BASE_URL + GENERATE_PDF_INVOICE,
      responseType: 'blob',
      data: dataInvoice,
      method: M_POST,
    })
      .then(({ data }) => {
        const dataFile = data;
        return {
          dataFile,
        };
      })
      .catch((err) => err);
  }

  @Action
  FetchTransaction(params) {
    return Vue.axios({
      url: BASE_URL + TRANSACTION_REPORT,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const {
          code,
          message,
        } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  FetchAgent(params) {
    return Vue.axios({
      url: BASE_URL + FECTH_AGENT,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const {
          code,
          message,
        } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Mutation
  mutateCSVReport(data: Blob) {
    this.dataCSV = data;
  }

  @Action
  async FetchCSVReport(params: any) {
    return Vue.axios({
      url: BASE_URL + WINLOSE_DOWNLOAD_REPORT_CSV,
      method: M_POST,
      responseType: 'blob',
      params: { rate: params.rate },
      data: JSON.stringify(params.criteria),
      headers: {
        'Content-Type': 'application/json', // Explicitly set the content type to JSON
      },
    })
      .then(({ data }) => data)
      .catch((err) => {
        throw err;
      });
  }
}
